import { ProfileModuleConfiguration } from '@profile/ui/ProfilePage/configuration';
import { ProfilePageName } from '@profile/ui/ProfilePage/types';

export const userProfilePages = new Set<ProfilePageName>([
    ProfilePageName.Profile,
    ProfilePageName.ScheduleSettings,
    ProfilePageName.SiteProfile,
    ProfilePageName.Prices,
    ProfilePageName.Notifications,
]);

export const profileModule: ProfileModuleConfiguration = {
    userProfilePages,
};
